import { fecha_actual } from "../hooks/elapsed";

export const ItemDocumentoComponente = ({ doc, index }: { doc: any; index: number }) => {
  // Extraemos la información del documento (si existe)
  const docData = doc.documento?.[0];
  const isLoaded = !!docData;
  const urlDoc = docData?.fc_ruta_documento || "";

  // Determinamos el tema (colores y etiquetas) en base al estatus
  let theme = {
    barColor: "bg-slate-300",
    badgeClasses: "bg-slate-100 text-slate-600 border-slate-200",
    dotColor: "bg-slate-400",
    label: "No Cargado",
    borderActive: "hover:border-slate-400",
  };

  if (isLoaded) {
    switch (docData.fi_rechazo_digital) {
      case 0: // Cargado pero no verificado
        theme = {
          barColor: "bg-emerald-500",
          badgeClasses: "bg-emerald-50 text-emerald-700 border-emerald-200",
          dotColor: "bg-emerald-500",
          label: "Documento Cargado",
          borderActive: "hover:border-emerald-300 border-t-emerald-500",
        };
        break;
      case 1: // Verificado
        theme = {
          barColor: "bg-brand-600",
          badgeClasses: "bg-brand-50 text-brand-800 border-brand-200",
          dotColor: "bg-brand-600",
          label: "Digital Verificado",
          borderActive: "hover:border-brand-300 border-t-brand-600",
        };
        break;
      case 2: // Rechazado
        theme = {
          barColor: "bg-amber-500",
          badgeClasses: "bg-amber-50 text-amber-800 border-amber-200",
          dotColor: "bg-amber-500",
          label: "Digital Rechazado",
          borderActive: "hover:border-amber-300 border-t-amber-500",
        };
        break;
      default:
        break;
    }
  }

  return (
    <article
      key={`${doc.id}-${index}`}
      className={`group flex flex-col justify-between overflow-hidden rounded-xl border border-slate-200 bg-white transition-all hover:shadow-md ${isLoaded ? 'card-active-border border-t-4' : ''} ${theme.borderActive}`}
    >
      {/* Barra de estado superior (Acento de color) */}
      {!isLoaded && <div className={`h-1.5 w-full transition-colors ${theme.barColor} group-hover:bg-slate-400`}></div>}

      <div className="flex flex-1 flex-col justify-between p-4 space-y-3">

        {/* --- Cabecera y Estatus --- */}
        <div>
          <div className="mb-2 flex items-start justify-between gap-2">
            <span className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[10px] font-semibold transition-colors ${theme.badgeClasses}`}>
              <span className={`h-1.5 w-1.5 rounded-full ${theme.dotColor}`}></span>
              {theme.label}
            </span>
          </div>
          <h4 className="text-xs font-bold leading-snug text-slate-900">
            {doc.fi_documento ? `${doc.fi_documento}. ` : ""}
            {doc.fc_nombre_documento}
          </h4>
          <p className="mt-1 line-clamp-2 text-[11px] leading-normal text-slate-500" title={doc.fc_descripcion_documento}>
            {doc.fc_descripcion_documento}
          </p>
        </div>

        {/* --- Caja de Metadatos (Fechas y SFTP) --- */}
        {isLoaded ? (
          <div className="space-y-1.5 rounded-lg border border-slate-100 bg-slate-50 p-2.5 text-[11px] font-mono text-slate-600">
            <div className="flex items-center justify-between">
              <span className="text-slate-400">Fecha Carga:</span>
              <span className="font-medium text-slate-800">
                {fecha_actual(docData.fd_fecha_carga) || "N/D"}
              </span>
            </div>
            {docData.fi_cargado_sftp === 1 && (
              <>
                <div className="flex items-center justify-between">
                  <span className="text-slate-400">SFTP Transmit:</span>
                  <span className="text-slate-500">
                    {fecha_actual(docData.fd_carga_sftp) || "N/D"}
                  </span>
                </div>
                <div className="flex items-center justify-between gap-2 truncate">
                  <span className="text-slate-400">Ruta:</span>
                  <span className="truncate font-semibold text-brand-600" title={docData.fc_sftp}>
                    {docData.fc_sftp || "N/D"}
                  </span>
                </div>
              </>
            )}
          </div>
        ) : (
          <div className="flex items-center justify-center rounded-lg border border-dashed border-slate-200 bg-slate-50/50 py-4 text-center">
            <span className="text-[10px] font-medium text-slate-400">Esperando documentación...</span>
          </div>
        )}

        {/* --- Barra de Acción Inferior --- */}
        <div className="mt-auto flex items-center justify-between border-t border-slate-100 pt-3">
          {isLoaded && urlDoc ? (
            <a
              href={urlDoc}
              target="_blank"
              rel="noreferrer"
              className="inline-flex w-full items-center justify-center gap-1.5 rounded-md bg-brand-50 px-3 py-1.5 text-xs font-semibold text-brand-700 transition-colors hover:bg-brand-100"
              title="Descargar archivo original"
            >
              <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"></path></svg>
              Descargar Archivo
            </a>
          ) : (
            <span className="text-[10px] text-slate-400">Sin archivo disponible</span>
          )}
        </div>

      </div>
    </article>
  );
};
